export * from './ng-table.module';
export * from './ng-table.component';
